import React, { useEffect } from 'react'

import { GetBrandedPage, allowNextSteps } from '../Branding'

export const ResultNextSteps = ({showFeedback=true}) => {

    useEffect(() => {
        window.scrollTo(0, 0)
    }, [])

    if(allowNextSteps) {
        const BrandedNextSteps = GetBrandedPage({pageName: 'next_steps', showFeedback})

        return <BrandedNextSteps />
    } else {
        return <>Page Not Found</>
    }
}